/**
 * This reducer handles the `questions` slice of the `TasteProfileOnboarding` domain
 */
import { QUESTION_ANSWERED } from './actions'
import { FETCH_QUESTIONS_SUCCESS } from '../../actions'
import { CLEAR_ANSWERS, SAVE_GENERATED_IMAGE_URLS } from '../../components/Start/actions'

function loadQuestions (state, action) {
  return Object.assign([], state, action.questions)
}

function answerQuestions (state, action) {
  const { questionId, chosenAnswer } = action.data
  const chosenIndex = state.findIndex((q) => q.id === questionId)

  return state.map((question, i) => {
    if (chosenIndex === i) {
      question.answered = chosenAnswer
    }
    return question
  })
}

function clearAnswers (state) {
  return state.map((question) => delete question.answered && question)
}

function saveGeneratedImageUrls (state, { payload }) {
  return [ ...payload ]
}

const initialState = []

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_QUESTIONS_SUCCESS:
      return loadQuestions(state, action)

    case QUESTION_ANSWERED:
      return answerQuestions(state, action)

    case CLEAR_ANSWERS:
      return clearAnswers(state)

    case SAVE_GENERATED_IMAGE_URLS:
      return saveGeneratedImageUrls(state, action)

    default:
      return state
  }
}
